import { TourStopItem } from '#components/tourdetails/TourStopItem.tsx';
import type { Tour } from '#domain/model/Tour.ts';

type TourStopListProps = {
    tour: Tour;
    setSelectedStopId: (stop?: string) => void;
};

export const TourStopList = ({ tour, setSelectedStopId }: TourStopListProps) => {
    const activeStopIndex = tour.stops.findIndex(stop => stop.status !== 'finished');
    return (
        <div className='timeline'>
            {tour.stops.map((stop, index) => {
                const transportOrders = tour.transportOrders.filter(order => stop.transportOrderIds.includes(order.id));
                const serviceOrders = tour.serviceOrders.filter(order => stop.serviceOrderIds.includes(order.id));
                return (
                    <TourStopItem
                        index={index}
                        stop={stop}
                        isActiveStop={index === activeStopIndex}
                        key={stop.id}
                        setSelectedStopId={setSelectedStopId}
                        transportOrders={transportOrders}
                        serviceOrders={serviceOrders}
                    />
                );
            })}
        </div>
    );
};
